// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ExploreRoot.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import {  get,uniqueId } from 'lodash/fp';
// share imports
import connect from 'share/enhancers/Izenda.Connect';
import MainWrapper from 'share/components/layout/Izenda.MainWrapper';
import MainContent from 'share/components/layout/Izenda.MainContent';
import NoRecordFound from 'share/components/controls/Izenda.NoRecordFound';
import uiState from 'logic/Izenda.UiState';
import routeUtils from 'share/utils/Izenda.RouteUtils';
// data imports
import ExploreStore from 'logic/Izenda.ExploreStore';
import SettingsStore from 'logic/Izenda.SettingsStore';
// local imports
import NLQQuery from 'modules/Explore/NLQQuery/Izenda.NLQQuery';
import NLQVisualization from 'modules/Explore/NLQVisualization/Izenda.NLQVisualization';
import NLQNav from './Header/Izenda.NLQNav';
import NLQAsk from './NLQAsk/Izenda.NLQAsk';
import { action, computed, observable,observe } from 'mobx';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';
import {PERMISSION_KEY} from 'logic/data/Izenda.AuthorizationConstants';
import SecurityManager from 'share/authorization/Izenda.SecurityManager';

@connect()
class ExploreRoot extends Component {
  constructor(props) {
    super(props);
    //this.authorization = new SecurityManager();
    this.initState();
  }

  initState(): void {
    var authorization = this.props.authorization;
    var hasnlqLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Nlq);
    var securityManager=new SecurityManager();
    var isShowExploreMenu = securityManager.checkPrivileges([PERMISSION_KEY.ReportsShowExploreMenuValue])
    if(!hasnlqLicense || !isShowExploreMenu)
    {
      const reportLink = routeUtils.getReportUrl();
      this.props.router.push(reportLink);
    }
     // License is expired, navigate to Settings pages
     if (uiState.expiredLicense) {
      const settingLink = routeUtils.getSettingsUrl();
      this.props.router.push(settingLink);
    }
    this.settingStore = new SettingsStore(true);
    this.locationKey = uniqueId('ExploreLocationKey_');
    this.exploreStore = new ExploreStore();
   
    if(uiState.currentUser.systemAdmin)
    {
      uiState.setDisableSettingLevel(true);
    }

    this.exploreStore.loadDashboardList();
    this.getNLQStatus();

    this.disposeObserveTenantID = observe(uiState, 'tenantId', () => {
      if (uiState.silentUpdate) return;
    this.getNLQStatus();
  });

  }
  componentWillReceiveProps(nextProps) {
    const isLocationChanged =
      !get('location.state.keepState', nextProps) &&
      nextProps.location.key !== this.props.location.key;
    isLocationChanged && this.initState();
  }
  componentWillUnmount() {
    //this.disposeObserveTenantId();
    this.settingStore.destroy();
  }
  getSuggestions = type => {
    let isTobeSearched = type === 'submit' ? true : false;
    this.exploreStore.SetISTobeSearch(isTobeSearched);
    let self = this;
    let { loader } = this.props;
    loader.startLoading();
    this.exploreStore
      .showSuggestResult(isTobeSearched)
      .then(response => {
        if (isTobeSearched) {
          this.setActive(2);
          self.exploreStore.setSuggestionSubmitModel(response.data);
        } else {
          self.exploreStore.setSuggestionChangeModel(response.data);
        }
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log(e);
      })
      .finally(loader.endLoading.bind(loader));
  };

  disabledWrapper = () => {
    this.exploreStore.resetResult();
  }

  setActive = activeTab => {
    if (activeTab === 1) {
      this.getSuggestions('change');
      this.exploreStore.initializeAskYourQueryValue();
      this.exploreStore.SetRecentReportView();
    } else if (activeTab === 2) {
      this.exploreStore.initializeQueryResultValue();
    } else if (activeTab === 3) {
      const isRecords =
      this.exploreStore.model.nlqDataandSchemaInfo && 
      this.exploreStore.model.nlqDataandSchemaInfo.nlqFustionResult &&
      this.exploreStore.model.nlqDataandSchemaInfo.nlqFustionResult.records.length > 0
        ? true
        : false;
      if (this.exploreStore.getISMLError == false && this.exploreStore.getShowResult && isRecords) {
        this.exploreStore.initializeVisualizationValue();
        this.getVisualizations();
      }
    }
  };
  getNLQStatus = () => {
    this.exploreStore
    .getConfigureNLQStatus()
    .then(response => {
      // console.log('The NLQ config response:', response);
      // set NLQ status which is coming in api response
      this.exploreStore.setNLQStatus(response);
      this.getSuggestions('change');
      this.exploreStore.SetRecentReportView();
    })
    .catch(e => {
      console.log(e);
    })
    .finally(console.log('config status call end.'));
  };
  getVisualizations = () => {
    const {
      exploreStore,
      props: { loader }
    } = this;
    loader.startLoading();
    exploreStore
      .getreportPartVisualization(exploreStore.getResultReportDefinition)
      .then(response => {
        exploreStore.defaultVisualizationHandler(response);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log(e);
      })
      .finally(loader.endLoading.bind(loader));
  };

  setSelectedSuggestion = suggestion => {
    this.exploreStore.setSearchstring(suggestion.name);
    this.exploreStore.setNLPDict(suggestion.nlpdict);
  };

  handleChange = e => {
    this.exploreStore.loadSearchList(e);
  };

  handleEnter = event => {
    if (event.key === 'Enter') {
      this.exploreStore.setSearchstring(event.target.value);
      this.getSuggestions('submit');
    }
  };

  render() {
    const isRecords =
      this.exploreStore.model.nlqDataandSchemaInfo && 
      this.exploreStore.model.nlqDataandSchemaInfo.nlqFustionResult &&
      this.exploreStore.model.nlqDataandSchemaInfo.nlqFustionResult.records.length > 0
        ? true
        : false;
    return (
      <div>
        <section className='izenda-Reports'>
          <MainWrapper settingStore={this.settingStore}>
            <div className='izenda-TableLayout u_paddingTopBottom'>
              <MainContent>
                <section className='izenda-Wrapper-header home-main-wrapper'>
                  <div className='board'>
                    <div>
                      <NLQNav
                        activeTab={this.exploreStore.model.activeTab}
                        isResult={
                          (isRecords && this.exploreStore.getResultReportDefinition) ||
                          (isRecords && this.exploreStore.model.nlqVisualizationReportDefinition)
                            ? true
                            : false
                        }
                        onActiveTab={this.setActive.bind(this)}
                      />
                    </div>
                  </div>
                  {this.exploreStore.getactiveTab == 1 && (
                    <NLQAsk
                      handleQueryChange={this.handleChange.bind(this)}
                      onEnter={this.handleEnter.bind(this)}
                      onSearch={this.getSuggestions.bind(this, 'submit')}
                      previewReport={this.exploreStore.preview.bind(this)}
                      onSelectedSuggestion={this.setSelectedSuggestion.bind(this)}
                      store={this.exploreStore}
                      disabledWrapper={this.disabledWrapper}
                    />
                  )}
                  {this.exploreStore.getactiveTab == 2 && this.exploreStore.getResultReportDefinition != null && (
                    <NLQQuery
                      {...this.props}
                      searchString={this.exploreStore.model.searchString}
                      store={this.exploreStore}
                      setActive={this.setActive.bind(this)}
                    />
                  )}

                  {this.exploreStore.getactiveTab == 3 &&
                    this.exploreStore.model.nlqVisualizationRecommendationList &&
                    this.exploreStore.model.nlqVisualizationRecommendationList.length > 0 &&
                    this.exploreStore.model.nlqVisualizationReportDefinition  && (
                      <NLQVisualization {...this.props} store={this.exploreStore} />
                    )}

                  {this.exploreStore.getISMLError ? (
                    <NoRecordFound containerClass='no-search-result-container' />
                  ) : null}
                </section>
              </MainContent>
            </div>
          </MainWrapper>
        </section>
      </div>
    );
  }
}
export default ExploreRoot;



// WEBPACK FOOTER //
// ./ui/modules/Explore/Izenda.ExploreRoot.jsx